import { makeConsentSelector, makeModuleApiInfoSelector } from "@client/content/selectors";
import { type RootContainerProps } from "@client/content/types";
import { connectCustom } from "@client/lib/misc";
import { getMultiselectValue } from "@client/lib/settings";
import {
  combinedSettingsSelector,
  getSettingSelector,
  makeModuleEntitySelector,
  TargetSelector
} from "@client/selectors";
import { type AppState, Status } from "@client/types";
import { type AnyAction } from "redux";
import { type ThunkDispatch } from "redux-thunk";
import { submitted, type SubmittedArgs } from "../actions";
import { localStateSelector } from "../selectors";
import Component, { type ActionProps, type MapProps } from "./component";
import { makeFieldsSelector, makeMessageSelector } from "./selectors";

export type Props = RootContainerProps & {
  formButtons?: any;
  isInPopup: boolean;
};

type Settings = {
  isInline: boolean;
  otpOptions: string[];
};
const makeMapStateToProps = () => {
  const fieldsSelector = makeFieldsSelector();
  const popupButtonInnerHorizontalAlignSelector = getSettingSelector(
    TargetSelector.Entity,
    "innerHorizontalAlign",
    "popup.button"
  );
  const consentSelector = makeConsentSelector();
  const settingsSelector = combinedSettingsSelector<Settings>(TargetSelector.Entity, [
    { name: "inline", prop: "isInline" },
    { name: "otp", converter: getMultiselectValue, prop: "otpOptions" }
  ]);
  const messageSelector = makeMessageSelector();
  const moduleApiInfoSelector = makeModuleApiInfoSelector();
  const moduleSelector = makeModuleEntitySelector();

  return (state: AppState, props: Props): MapProps => {
    const localState = localStateSelector(state, props);
    const settings = settingsSelector(state, props);
    const consent = consentSelector(state, {
      id: props.id,
      source: props.source,
      consentFieldIds: localState.consentFieldIds
    });
    const module = moduleSelector(state, props);

    return {
      ...props,
      ...settings,
      consent,
      error: localState.error,
      canSubmit: localState.isAllowed && localState.status !== Status.Saving,
      fieldErrors: localState.fieldErrors,
      fields: fieldsSelector(state, props),
      message: messageSelector(state, props),
      moduleApiInfo: moduleApiInfoSelector(state, props),
      isRegisterModule: module.moduleType === "Register",
      popupButtonsAlign: popupButtonInnerHorizontalAlignSelector(state, props)
    };
  };
};

const mapDispatchToProps = (dispatch: ThunkDispatch<AppState, any, AnyAction>, props: Props): ActionProps => ({
  onSubmitted: (args: SubmittedArgs) => dispatch(submitted({ id: props.id, source: props.source }, args))
});

export default connectCustom(makeMapStateToProps, mapDispatchToProps)(Component);
